<div class="wrapper" [ngClass]="{'checkout-item': _variant === VARIANT_CHECKOUT_ITEM, 'cart-item': _variant === VARIANT_CART_ITEM}">
  @if (loading) {
    <app-spinner></app-spinner>
  }
  @if (!loading) {
    <div class="container">
      <div class="item-contents flex">
        <div>
          @if (subscription.membershipLevel === 'Gold') {
            <div class="gold gold-membership gold-background">
              <div class="wwm-icon"></div>
            </div>
          }
          @if (subscription.membershipLevel === 'Platinum') {
            <div class="platinum platinum-membership platinum-background">
              <div class="wwm-icon"></div>
            </div>
          }
        </div>
        <div class="item-details">
          <div class="row">
            <div>
              <p class="title">{{subscription.membershipLevel}} Membership</p>
              <p>Recurs each year at $125/yr, good for up to $200 of discounts</p>
            </div>
            <p class="total-amount ml-10">${{subscription.paymentAmount?.toFixed(2)}}</p>
          </div>
        </div>
      </div>
      <div class="button regular close" (click)="openConfirmationModal()"><span class="icon">&#x00D7;</span></div>
    </div>
  }
</div>
<app-confirm-modal
  [modalId]="modalId"
  [text]="confirmText"
  [buttonText]="buttonText"
  (confirmChoice)="onItemRemove($event)"
></app-confirm-modal>
<app-error-modal [modalId]="'cart-item-error-modal'" [text]="errorText"></app-error-modal>
